import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useQuery } from '../common/hooks/useQuery';
import { GetCurrentLanguage, HandleChangeLang } from '../util/ChangeLanguage';

const ChangeLanguage = () => {
  var curLang = GetCurrentLanguage();
  const query = useQuery();
  const history = useHistory();
  const { search, pathname } = useLocation();

  const langQuery = query.get('lang');
  const url = new URLSearchParams(search);

  const [lang, setLang] = useState(curLang);

  useEffect(() => {
    if (langQuery) {
      setLang(langQuery);
    }
  }, []);

  useEffect(() => {
    if (lang) {
      HandleChangeLang(lang);
      if (langQuery) {
        url.set('lang', lang);
        history.replace({ pathname, search: url.toString() });
      }
    }
  }, [lang]);

  return (
    <div className="dropdown inline-block relative ">
      <div className="font-semibold my-2 inline-flex items-center bg-[#B6DAFC] p-2 rounded-full">
        {lang === 'vi-VN' && <img src="/vietnamese.png" />}
        {lang === 'en-US' && <img src="/united-kingdom.png" />}
        {lang === 'ja-JP' && <img src="/japanese.png" />}
      </div>
      <ul className="dropdown-menu absolute right-0 text-[#172B4D] bg-[#E2E3E9] hidden pt-1 w-36 rounded-[3px]">
        <li
          onClick={() => {
            setLang('vi-VN');
          }}
          className={`${
            lang === 'vi-VN' ? 'hidden' : 'block'
          } hover:bg-[#D3EEFF] cursor-pointer`}
        >
          <div className="flex w-full justify-between px-2 py-2">
            <div className="mx-2 my-auto">Tiếng Việt</div>
            <img src="/vietnamese.png" />
          </div>
        </li>
        <li
          onClick={() => {
            setLang('en-US');
          }}
          className={`${
            lang === 'en-US' ? 'hidden' : 'block'
          } hover:bg-[#D3EEFF] cursor-pointer`}
        >
          <div className="flex w-full justify-between px-2 py-2">
            <div className="mx-2 my-auto">English</div>
            <img src="/united-kingdom.png" />
          </div>
        </li>
        <li
          onClick={() => {
            setLang('ja-JP');
          }}
          className={`${
            lang === 'ja-JP' ? 'hidden' : 'block'
          } hover:bg-[#D3EEFF] cursor-pointer`}
        >
          <div className="flex w-full justify-between px-2 py-2">
            <div className="mx-2 my-auto">日本</div>
            <img src="/japanese.png" />
          </div>
        </li>
      </ul>
    </div>
  );
};

export default ChangeLanguage;
